<template>
	<div>
		<b-modal v-model="modal">
			<template #modal-header>
				<h5>{{ description }}</h5>
			</template>

			<template #default>
				<span v-if="activity.id" class="text-muted"> # {{ activity.id }} </span>
				<br v-if="activity.id" />
				<span v-if="activity.name"
					><strong>Nome:</strong> {{ activity.name }}
				</span>
				<br v-if="activity.name" />
				<span><strong>Descrição:</strong> {{ activity.description }} </span>
				<br v-if="activity.document" />
				<span v-if="activity.document"
					><strong>Documento:</strong> {{ activity.document }}
				</span>
			</template>

			<template #modal-footer>
				<button
					@click="modal = false"
					role="button"
					class="btn btn-outline-secondary"
				>
					Voltar
				</button>
			</template>
		</b-modal>
	</div>
</template>

<script>
	export default {

		data() {
			return {
				modal: false,
				description: null,
			}
		},

		computed: {
			activityDescription() {
				return this.$store.state.activity.description;
			},
			activity() {
				return this.$store.state.activity.activity;
			},
		},

		methods: {
			open(params) {
				this.$store.commit("showLoading");
				this.$store.dispatch("activity/getActivity", { id: params.id, params: params })
					.then(response => {
						this.setActivityDescription(params.action);
						this.modal = true;
						this.$store.commit("hideLoading");
					})
					.catch(error => {
						this.$store.commit("hideLoading");
						this.modal = false;
					});
			},

			setActivityDescription(action) {

				this.description = this.activityDescription.filter((activity) =>
					(activity.action == action))[0].description;

			},
		},
	}
</script>